import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  getSettingsFailure,
  getSettingsSuccess,
  updateSettingsFailure,
  updateSettingsSuccess,
} from "../../actions";
import { GET_SETTINGS, UPDATE_SETTINGS } from "../../Actions/types";
import api from "../../../helper/api";

function* fetchSettings(action) {
  try {
    const response = yield api.get(
       "/admin/settings/setting-list",
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(getSettingsSuccess({ getData: response?.data?.data }));
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(getSettingsFailure({ getError: e }));
  }
}

function* fetchSettingsUpdate(action) {
  try {
    const response = yield api.put(
       `/admin/settings/edit-setting/${action?.payload?.form?.id}`,
      action?.payload?.form,
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(updateSettingsSuccess({ updateData: response?.data?.data }));
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(updateSettingsFailure({ updateError: e }));
  }
}
function* settingsWatcher() {
  yield takeLatest(GET_SETTINGS, fetchSettings);
}

function* settingsUpdateWatcher() {
  yield takeLatest(UPDATE_SETTINGS, fetchSettingsUpdate);
}

export default function* settingsSaga() {
  yield all([settingsWatcher(), settingsUpdateWatcher()]);
}
